import getCurrentReduxSelector from 'modules/redux/selectors/get-current'
import { CUSTOMERS_PATH } from 'modules/training/modules/customer/constants'

const getCurrentCustomerSelect = getCurrentReduxSelector(
  CUSTOMERS_PATH.DATA,
  CUSTOMERS_PATH.CURRENT
)

export default getCurrentCustomerSelect
